var Ee = (a) => {
  throw TypeError(a);
};
var Se = (a, l, t) => l.has(a) || Ee("Cannot " + t);
var Me = (a, l, t) => (Se(a, l, "read from private field"), t ? t.call(a) : l.get(a)), Ce = (a, l, t) => l.has(a) ? Ee("Cannot add the same private member more than once") : l instanceof WeakSet ? l.add(a) : l.set(a, t), oe = (a, l, t, i) => (Se(a, l, "write to private field"), i ? i.call(a, t) : l.set(a, t), t);
import { i as H, e as q } from "./reactive-element-CzWTglSF.js";
import "../beacon-html.d/index.js";
import { r as De } from "./lit-element-sPTOReu4.js";
import { property as P } from "../beacon-property.d/index.js";
import { state as Te } from "../beacon-state.d/index.js";
import { unsafeStatic as Ge } from "../beacon-static-html.d/index.js";
import { B as L } from "./events-CMiHMbSn.js";
(function() {
  (function(a) {
    const l = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), D = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), V = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, Oe = (o, e) => {
      for (let r in V) {
        e[r] = null;
        let n = null;
        const d = V[r];
        Object.defineProperty(e, r, {
          get() {
            return n;
          },
          set(u) {
            n = u, o.isConnected ? A(o, d, u) : p.set(o, e);
          }
        });
      }
    };
    function ne(o) {
      const e = s.get(o), { form: r } = e;
      fe(o, r, e), ue(o, e.labels);
    }
    const ae = (o, e = !1) => {
      const r = document.createTreeWalker(o, NodeFilter.SHOW_ELEMENT, {
        acceptNode(u) {
          return s.has(u) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let n = r.nextNode();
      const d = !e || o.disabled;
      for (; n; )
        n.formDisabledCallback && d && J(n, o.disabled), n = r.nextNode();
    }, le = { attributes: !0, attributeFilter: ["disabled", "name"] }, j = z() ? new MutationObserver((o) => {
      for (const e of o) {
        const r = e.target;
        if (e.attributeName === "disabled" && (r.constructor.formAssociated ? J(r, r.hasAttribute("disabled")) : r.localName === "fieldset" && ae(r)), e.attributeName === "name" && r.constructor.formAssociated) {
          const n = s.get(r), d = g.get(r);
          n.setFormValue(d);
        }
      }
    }) : {};
    function X(o) {
      o.forEach((e) => {
        const { addedNodes: r, removedNodes: n } = e, d = Array.from(r), u = Array.from(n);
        d.forEach((h) => {
          var w;
          if (s.has(h) && h.constructor.formAssociated && ne(h), p.has(h)) {
            const y = p.get(h);
            Object.keys(V).filter((C) => y[C] !== null).forEach((C) => {
              A(h, V[C], y[C]);
            }), p.delete(h);
          }
          if (M.has(h)) {
            const y = M.get(h);
            A(h, "internals-valid", y.validity.valid.toString()), A(h, "internals-invalid", (!y.validity.valid).toString()), A(h, "aria-invalid", (!y.validity.valid).toString()), M.delete(h);
          }
          if (h.localName === "form") {
            const y = f.get(h), I = document.createTreeWalker(h, NodeFilter.SHOW_ELEMENT, {
              acceptNode(te) {
                return s.has(te) && te.constructor.formAssociated && !(y && y.has(te)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let C = I.nextNode();
            for (; C; )
              ne(C), C = I.nextNode();
          }
          h.localName === "fieldset" && ((w = j.observe) === null || w === void 0 || w.call(j, h, le), ae(h, !0));
        }), u.forEach((h) => {
          const w = s.get(h);
          w && i.get(w) && ce(w), m.has(h) && m.get(h).disconnect();
        });
      });
    }
    function Ne(o) {
      o.forEach((e) => {
        const { removedNodes: r } = e;
        r.forEach((n) => {
          const d = S.get(e.target);
          s.has(n) && me(n), d.disconnect();
        });
      });
    }
    const Fe = (o) => {
      var e, r;
      const n = new MutationObserver(Ne);
      !((e = window == null ? void 0 : window.ShadyDOM) === null || e === void 0) && e.inUse && o.mode && o.host && (o = o.host), (r = n.observe) === null || r === void 0 || r.call(n, o, { childList: !0 }), S.set(o, n);
    };
    z() && new MutationObserver(X);
    const Y = {
      childList: !0,
      subtree: !0
    }, A = (o, e, r) => {
      o.getAttribute(e) !== r && o.setAttribute(e, r);
    }, J = (o, e) => {
      o.toggleAttribute("internals-disabled", e), e ? A(o, "aria-disabled", "true") : o.removeAttribute("aria-disabled"), o.formDisabledCallback && o.formDisabledCallback.apply(o, [e]);
    }, ce = (o) => {
      i.get(o).forEach((r) => {
        r.remove();
      }), i.set(o, []);
    }, de = (o, e) => {
      const r = document.createElement("input");
      return r.type = "hidden", r.name = o.getAttribute("name"), o.after(r), i.get(e).push(r), r;
    }, Pe = (o, e) => {
      var r;
      i.set(e, []), (r = j.observe) === null || r === void 0 || r.call(j, o, le);
    }, ue = (o, e) => {
      if (e.length) {
        Array.from(e).forEach((n) => n.addEventListener("click", o.click.bind(o)));
        let r = e[0].id;
        e[0].id || (r = `${e[0].htmlFor}_Label`, e[0].id = r), A(o, "aria-labelledby", r);
      }
    }, K = (o) => {
      const e = Array.from(o.elements).filter((u) => !u.tagName.includes("-") && u.validity).map((u) => u.validity.valid), r = f.get(o) || [], n = Array.from(r).filter((u) => u.isConnected).map((u) => s.get(u).validity.valid), d = [...e, ...n].includes(!1);
      o.toggleAttribute("internals-invalid", d), o.toggleAttribute("internals-valid", !d);
    }, Ve = (o) => {
      K(B(o.target));
    }, Re = (o) => {
      K(B(o.target));
    }, $e = (o) => {
      const e = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((r) => `${r}:not([disabled])`).map((r) => `${r}:not([form])${o.id ? `,${r}[form='${o.id}']` : ""}`).join(",");
      o.addEventListener("click", (r) => {
        if (r.target.closest(e)) {
          const d = f.get(o);
          if (o.noValidate)
            return;
          d.size && Array.from(d).reverse().map((w) => s.get(w).reportValidity()).includes(!1) && r.preventDefault();
        }
      });
    }, He = (o) => {
      const e = f.get(o.target);
      e && e.size && e.forEach((r) => {
        r.constructor.formAssociated && r.formResetCallback && r.formResetCallback.apply(r);
      });
    }, fe = (o, e, r) => {
      if (e) {
        const n = f.get(e);
        if (n)
          n.add(o);
        else {
          const d = /* @__PURE__ */ new Set();
          d.add(o), f.set(e, d), $e(e), e.addEventListener("reset", He), e.addEventListener("input", Ve), e.addEventListener("change", Re);
        }
        b.set(e, { ref: o, internals: r }), o.constructor.formAssociated && o.formAssociatedCallback && setTimeout(() => {
          o.formAssociatedCallback.apply(o, [e]);
        }, 0), K(e);
      }
    }, B = (o) => {
      let e = o.parentNode;
      return e && e.tagName !== "FORM" && (e = B(e)), e;
    }, k = (o, e, r = DOMException) => {
      if (!o.constructor.formAssociated)
        throw new r(e);
    }, he = (o, e, r) => {
      const n = f.get(o);
      return n && n.size && n.forEach((d) => {
        s.get(d)[r]() || (e = !1);
      }), e;
    }, me = (o) => {
      if (o.constructor.formAssociated) {
        const e = s.get(o), { labels: r, form: n } = e;
        ue(o, r), fe(o, n, e);
      }
    };
    function z() {
      return typeof MutationObserver < "u";
    }
    class Ue {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const We = (o) => (o.badInput = !1, o.customError = !1, o.patternMismatch = !1, o.rangeOverflow = !1, o.rangeUnderflow = !1, o.stepMismatch = !1, o.tooLong = !1, o.tooShort = !1, o.typeMismatch = !1, o.valid = !0, o.valueMissing = !1, o), _e = (o, e, r) => (o.valid = je(e), Object.keys(e).forEach((n) => o[n] = e[n]), r && K(r), o), je = (o) => {
      let e = !0;
      for (let r in o)
        r !== "valid" && o[r] !== !1 && (e = !1);
      return e;
    }, Q = /* @__PURE__ */ new WeakMap();
    function pe(o, e) {
      o.toggleAttribute(e, !0), o.part && o.part.add(e);
    }
    class Z extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(e) {
        if (super(), !e || !e.tagName || e.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        Q.set(this, e);
      }
      add(e) {
        if (!/^--/.test(e) || typeof e != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${e} must start with '--'.`);
        const r = super.add(e), n = Q.get(this), d = `state${e}`;
        return n.isConnected ? pe(n, d) : setTimeout(() => {
          pe(n, d);
        }), r;
      }
      clear() {
        for (let [e] of this.entries())
          this.delete(e);
        super.clear();
      }
      delete(e) {
        const r = super.delete(e), n = Q.get(this);
        return n.isConnected ? (n.toggleAttribute(`state${e}`, !1), n.part && n.part.remove(`state${e}`)) : setTimeout(() => {
          n.toggleAttribute(`state${e}`, !1), n.part && n.part.remove(`state${e}`);
        }), r;
      }
    }
    function be(o, e, r, n) {
      if (typeof e == "function" ? o !== e || !0 : !e.has(o)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return r === "m" ? n : r === "a" ? n.call(o) : n ? n.value : e.get(o);
    }
    function Ke(o, e, r, n, d) {
      if (typeof e == "function" ? o !== e || !0 : !e.has(o)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return e.set(o, r), r;
    }
    var U;
    class Be {
      constructor(e) {
        U.set(this, void 0), Ke(this, U, e);
        for (let r = 0; r < e.length; r++) {
          let n = e[r];
          this[r] = n, n.hasAttribute("name") && (this[n.getAttribute("name")] = n);
        }
        Object.freeze(this);
      }
      get length() {
        return be(this, U, "f").length;
      }
      [(U = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return be(this, U, "f")[Symbol.iterator]();
      }
      item(e) {
        return this[e] == null ? null : this[e];
      }
      namedItem(e) {
        return this[e] == null ? null : this[e];
      }
    }
    function ze() {
      const o = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = r;
      const e = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = n;
      function r(...u) {
        let h = o.apply(this, u);
        return he(this, h, "checkValidity");
      }
      function n(...u) {
        let h = e.apply(this, u);
        return he(this, h, "reportValidity");
      }
      const { get: d } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...u) {
          const h = d.call(this, ...u), w = Array.from(f.get(this) || []);
          if (w.length === 0)
            return h;
          const y = Array.from(h).concat(w).sort((I, C) => I.compareDocumentPosition ? I.compareDocumentPosition(C) & 2 ? 1 : -1 : 0);
          return new Be(y);
        }
      });
    }
    class ye {
      static get isPolyfilled() {
        return !0;
      }
      constructor(e) {
        if (!e || !e.tagName || e.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const r = e.getRootNode(), n = new Ue();
        this.states = new Z(e), l.set(this, e), t.set(this, n), s.set(e, this), Oe(e, this), Pe(e, this), Object.seal(this), r instanceof DocumentFragment && Fe(r);
      }
      checkValidity() {
        const e = l.get(this);
        if (k(e, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const r = t.get(this);
        if (!r.valid) {
          const n = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          e.dispatchEvent(n);
        }
        return r.valid;
      }
      get form() {
        const e = l.get(this);
        k(e, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let r;
        return e.constructor.formAssociated === !0 && (r = B(e)), r;
      }
      get labels() {
        const e = l.get(this);
        k(e, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const r = e.getAttribute("id"), n = e.getRootNode();
        return n && r ? n.querySelectorAll(`[for="${r}"]`) : [];
      }
      reportValidity() {
        const e = l.get(this);
        if (k(e, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const r = this.checkValidity(), n = D.get(this);
        if (n && !e.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !r && n && (e.focus(), n.focus()), r;
      }
      setFormValue(e) {
        const r = l.get(this);
        if (k(r, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), ce(this), e != null && !(e instanceof FormData)) {
          if (r.getAttribute("name")) {
            const n = de(r, this);
            n.value = e;
          }
        } else e != null && e instanceof FormData && Array.from(e).reverse().forEach(([n, d]) => {
          if (typeof d == "string") {
            const u = de(r, this);
            u.name = n, u.value = d;
          }
        });
        g.set(r, e);
      }
      setValidity(e, r, n) {
        const d = l.get(this);
        if (k(d, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !e)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        D.set(this, n);
        const u = t.get(this), h = {};
        for (const I in e)
          h[I] = e[I];
        Object.keys(h).length === 0 && We(u);
        const w = Object.assign(Object.assign({}, u), h);
        delete w.valid;
        const { valid: y } = _e(u, w, this.form);
        if (!y && !r)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        c.set(this, y ? "" : r), d.isConnected ? (d.toggleAttribute("internals-invalid", !y), d.toggleAttribute("internals-valid", y), A(d, "aria-invalid", `${!y}`)) : M.set(d, this);
      }
      get shadowRoot() {
        const e = l.get(this), r = E.get(e);
        return r || null;
      }
      get validationMessage() {
        const e = l.get(this);
        return k(e, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), c.get(this);
      }
      get validity() {
        const e = l.get(this);
        return k(e, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), t.get(this);
      }
      get willValidate() {
        const e = l.get(this);
        return k(e, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(e.disabled || e.hasAttribute("disabled") || e.hasAttribute("readonly"));
      }
    }
    function qe() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class o extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const e = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(e, o);
      const r = new o();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((n) => n in r.internals);
    }
    let ge = !1, ve = !1;
    function ee(o) {
      ve || (ve = !0, window.CustomStateSet = Z, o && (HTMLElement.prototype.attachInternals = function(...e) {
        const r = o.call(this, e);
        return r.states = new Z(this), r;
      }));
    }
    function we(o = !0) {
      if (!ge) {
        if (ge = !0, typeof window < "u" && (window.ElementInternals = ye), typeof CustomElementRegistry < "u") {
          const e = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(r, n, d) {
            if (n.formAssociated) {
              const u = n.prototype.connectedCallback;
              n.prototype.connectedCallback = function() {
                F.has(this) || (F.set(this, !0), this.hasAttribute("disabled") && J(this, !0)), u != null && u.apply(this), me(this);
              };
            }
            e.call(this, r, n, d);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (s.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new ye(this);
        }), typeof Element < "u") {
          let e = function(...n) {
            const d = r.apply(this, n);
            if (E.set(this, d), z()) {
              const u = new MutationObserver(X);
              window.ShadyDOM ? u.observe(this, Y) : u.observe(d, Y), m.set(this, u);
            }
            return d;
          };
          const r = Element.prototype.attachShadow;
          Element.prototype.attachShadow = e;
        }
        z() && typeof document < "u" && new MutationObserver(X).observe(document.documentElement, Y), typeof HTMLFormElement < "u" && ze(), (o || typeof window < "u" && !window.CustomStateSet) && ee();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (qe() ? typeof window < "u" && !window.CustomStateSet && ee(HTMLElement.prototype.attachInternals) : we(!1)), a.forceCustomStateSetPolyfill = ee, a.forceElementInternalsPolyfill = we, Object.defineProperty(a, "__esModule", { value: !0 }), a;
  })({});
})();
var G = /* @__PURE__ */ ((a) => (a.NO_SYNC = "no-sync", a))(G || {}), R = /* @__PURE__ */ ((a) => (a.VISIBLE = "visible", a.IDLE = "idle", a.INTERACTION = "interaction", a.MEDIA = "media", a.DEFINED = "defined", a))(R || {});
const Xe = H`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}[beacon-tag-name]:not([focus-override]) *:focus-visible:not(.beacon-control__field,.skip-focus-override,a:not([focus-override])):not(dialog){position:relative}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, xe = H`:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}:host(:not([focus-override],.skip-focus-override)) *:not(.skip-focus-override,a:not([focus-override])):focus-visible:not(dialog){position:relative}:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{background-color:var(--beacon-system-color-background-link-focus)!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo) 0 0 var(--beacon-system-color-border-link-focus);color:var(--beacon-system-color-text-set-navy)!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override],.skip-focus-override)) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo) solid var(--beacon-system-color-border-link-focus)}}`, Ye = H`:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-small);--motion-translate-intro-micro: 3rem}@media (width >= 640px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-medium);--motion-translate-intro-micro: 4rem}}@media (width >= 960px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-large);--motion-translate-intro-micro: 5rem}}@media (width >= 1280px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-x-large);--motion-translate-intro-micro: 6rem}}@media (width >= 1600px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xx-large);--motion-translate-intro-micro: 8rem}}@media (width >= 1920px){:root{--motion-translate-intro-macro: var(--beacon-system-breakpoint-xxx-large);--motion-translate-intro-micro: 9rem}}`, Je = H`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, Ae = H`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}::slotted(:is(ul,ol)[role=list]){list-style:none;padding:0}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, Le = H`.has-cell-padding,.has-component-padding{padding-block:var(--beacon-reference-space-3);padding-inline:var(--beacon-reference-space-3)}:host{color:var(--beacon-system-color-text-standard);font-family:var(--beacon-system-font-family-body);-webkit-font-smoothing:antialiased;font-weight:var(--beacon-system-font-weight-light)}a,::slotted(a){color:var(--beacon-system-color-text-link)}a:not([class],:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var _ = /* @__PURE__ */ ((a) => (a.CLICKABLE = "data-metrics-clickable", a.TYPE = "data-metrics-type", a.TEXT = "data-metrics-link-text", a.LOCATION = "data-metrics-location", a))(_ || {});
const O = class O {
};
O.setPropertyOnEvent = (l, t, i, s) => {
  try {
    Object.defineProperty(l, i, {
      value: s || t[`${i}`],
      writable: !1
    });
  } catch (c) {
    console.warn(c);
  }
}, O.getAnalyticsEvents = () => {
  const l = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((t) => /^on/.test(t) && new RegExp(l.join("|")).test(t) && t !== "onscrollsnapchange");
}, O.setHostEventHandlerForAnalytics = (l, t) => {
  var c;
  const i = O.getAnalyticsEvents(), s = "beaconVersion";
  for (const b of i) {
    const m = b.slice(2);
    (c = l.shadowRoot) == null || c.addEventListener(
      m,
      (f) => {
        var p;
        const g = new f.constructor(
          m,
          f
        );
        O.setPropertyOnEvent(
          g,
          null,
          s,
          t
        );
        for (const E in f)
          E !== "isTrusted" && O.setPropertyOnEvent(g, f, E);
        (p = l.shadowRoot) != null && p.contains(f.target) && l.dispatchEvent(g);
      },
      !0
    );
  }
};
let se = O;
function ht(a, l) {
  !a || !l || a instanceof SVGElement && (a.setAttribute(_.CLICKABLE, "true"), a.setAttribute(_.TYPE, "BTN"), a.getAttribute(_.TEXT) || a.setAttribute(_.TEXT, l));
}
function mt(a) {
  return !!a.updateAnalytics;
}
function W(a, l, t, i) {
  const s = new CustomEvent(l, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...t
  });
  return a.dispatchEvent(s), i && i(), s;
}
const ke = (a) => !!a.deferrable, Qe = (a) => {
  var l, t;
  return (!!((l = a.deferList) != null && l.includes(R.VISIBLE)) || !!((t = a.getAttribute("defer-until")) != null && t.includes(R.VISIBLE))) && a.isDeferUntilParent;
}, Ie = (a) => !!navigator.vendor && navigator.vendor.indexOf(a) > -1;
function Ze(a) {
  return `${a}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(
    new RegExp(/\s+(.)(\w*)/, "g"),
    (l, t, i) => `${t.toUpperCase() + i}`
  ).replace(new RegExp(/\w/), (l) => l.toUpperCase());
}
const et = "4.3.1", tt = {
  rootMargin: "1500px",
  threshold: 0
}, T = {
  version: et,
  hidden: "hidden",
  safari: "Apple",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: tt
}, re = (a) => {
  for (const l of a)
    if (l !== void 0) return l;
};
class ie extends CSSStyleSheet {
  constructor(l, t) {
    super(), this.name = l, this.replaceSync(t);
  }
}
var ot = Object.defineProperty, N = (a, l, t, i) => {
  for (var s = void 0, c = a.length - 1, b; c >= 0; c--)
    (b = a[c]) && (s = b(l, t, s) || s);
  return s && ot(l, t, s), s;
};
const rt = [Ae, Le, xe];
var $, v;
const x = (v = class extends De {
  constructor() {
    super();
    Ce(this, $);
    oe(this, $, !1), this.isDeferUntilParent = !1, this.deferrable = !0, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = T.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (t) => {
      const { target: i } = t, s = i.name;
      this.slotDeprecationWarn(s);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: T.defaultDeferOptions.rootMargin,
      threshold: T.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((t) => {
      if (!("IntersectionObserver" in window))
        t();
      else {
        const i = new IntersectionObserver((s) => {
          const [c] = s;
          c.isIntersecting && (i.disconnect(), t());
        }, this.getResolvedDeferOptions() || null);
        i.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const t = new Promise((i) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => i(), { once: !0 }) : i();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((i) => {
          requestIdleCallback(() => {
            i();
          });
        }),
        t
      ]) : t;
    }, this.deferredChildEventHandler = (t) => new Promise((i) => {
      var s;
      t instanceof CustomEvent && ((s = t.detail) != null && s.type) ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(t.detail.type).then(() => i())) : i();
    }), this.renderStyles = (t, i) => {
      const s = [], c = new Set(
        this.constructor[t].flat(1 / 0)
      );
      for (const b of c)
        s.push(b);
      q ? s.forEach((b, m) => {
        var E, D, S;
        const f = this.getClosestHost(), g = `${i}-${m}`, p = new ie(g, b.toString());
        if (f) {
          if (!((E = f.shadowRoot) == null ? void 0 : E.adoptedStyleSheets.find(
            (M) => M.name === g
          )))
            if (p.name.includes("global-light")) {
              const M = parseInt(p.name.slice(-1), 10);
              (D = f.shadowRoot) == null || D.adoptedStyleSheets.splice(
                rt.length + M,
                0,
                p
              );
            } else
              (S = f.shadowRoot) == null || S.adoptedStyleSheets.push(p);
        } else if (!document.adoptedStyleSheets.find(
          (F) => F.name === g
        ))
          if (p.name.includes("global-light")) {
            const F = parseInt(p.name.slice(-1), 10) + 1, M = document.adoptedStyleSheets.findLastIndex(
              (V) => V.name.includes("global-root")
            );
            document.adoptedStyleSheets.splice(M + F, 0, p);
          } else
            document.adoptedStyleSheets.push(p);
      }) : s.toReversed().forEach((b, m) => {
        var p;
        const f = document.createElement("style");
        f.setAttribute("slot", "lightDOM");
        let g = !1;
        if (f.textContent = b.toString(), i) {
          const E = Math.abs(m - s.length), D = `${i}-${E}`, S = this.getClosestHost();
          f.id = D, (S && ((p = S == null ? void 0 : S.shadowRoot) != null && p.querySelector(`#${D}`)) || !S && document.querySelector(`#${D}`)) && (g = !0);
        }
        g || this.prepend(f);
      });
    }, this.renderComponentModeStyles = (t = `${this.beaconTagName}-mode-styles`) => {
      var i, s;
      q ? (i = this.componentModeStyles) == null || i.forEach(
        (c, b) => {
          if (!document.adoptedStyleSheets.find(
            (m) => m.name === `${t}-${b}`
          )) {
            const m = new ie(
              `${t}-${b}`,
              c.toString()
            );
            document.adoptedStyleSheets.push(m);
          }
        }
      ) : (s = this.componentModeStyles) == null || s.forEach((c, b) => {
        const m = document.createElement("style");
        m.textContent = c.toString();
        const f = `${t}-${b}`;
        m.id = f, !document.querySelector(`#${f}`) && document.head.append(m);
      });
    }, this.getScopedTag = (t) => {
      if (!t) return null;
      const i = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${t}` : t;
      return Ge(i);
    }, this._internals = this.attachInternals ? this.attachInternals() : void 0;
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const t = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((i, s) => {
      this.elementProperties.has(i) && t.push(s);
    }), t.push(...super.observedAttributes), t;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(t, i, s) {
    const {
      alternateAttributesMap: c,
      hasDeprecatedProperties: b,
      elementProperties: m
    } = this.constructor;
    if (b && c.size > 0) {
      const f = c.get(t), g = this.getPropertyOptions(t).alternateSlot;
      if (f) {
        const p = m.get(f);
        if (f !== G.NO_SYNC && (s === null ? this.removeAttribute(
          (p == null ? void 0 : p.attribute) || f
        ) : this.setAttribute(
          (p == null ? void 0 : p.attribute) || f,
          s || ""
        )), g) {
          const E = this.createPropertyDeprecationForSlotMessage(t, g);
          console.warn(E);
        } else
          console.warn(
            this.createPropertyDeprecationMessage(
              t,
              f,
              p == null ? void 0 : p.attribute
            )
          );
      }
    }
    super.attributeChangedCallback(t, i, s);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param prop property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(t, i, s) {
    let c = `Beacon Warning: [${t}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return i !== G.NO_SYNC && (c += ` Start using [${s || i}] instead to avoid future disruptions.`), c;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(t, i) {
    return `Beacon Warning: '${t}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${i}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(t, i) {
    if (i) {
      const { alternateAttributes: s, attribute: c } = i, b = Object.prototype.hasOwnProperty.call(
        i,
        "sync"
      );
      if (T.deprecatedPropertyKeys.forEach((m) => {
        Object.prototype.hasOwnProperty.call(i, m) && (this.hasDeprecatedProperties = !0);
      }), s && s.forEach((m) => {
        this.alternateAttributesMap.set(m, t);
      }), b && !i.sync) {
        const m = c != null ? c : t;
        this.alternateAttributesMap.set(
          m,
          G.NO_SYNC
        );
      }
    }
    super.createProperty(t, i);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(t) {
    var s;
    const { elementProperties: i } = this.constructor;
    return (s = i.get(t)) != null ? s : [...i.values()].find(
      (c) => c.attribute === t
    );
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /** callback method for the beacon-on-click event*/
  onBeaconClick() {
  }
  /** callback method for the beacon-on-keydown event*/
  onBeaconKeydown() {
  }
  /** callback method for the beacon-on-toggle event*/
  onBeaconToggle() {
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var t, i;
    return (i = (t = this.deferUntil) == null ? void 0 : t.split(" ").map((s) => s).filter((s) => !!s)) != null ? i : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(t) {
    const i = this.alternateSlots.get(t);
    if (i !== void 0) {
      let s;
      const c = `The '${t}' for for '${this.beaconTagName}'`;
      Object.keys(i).some((b) => b.match("alternate")) ? i.alternateAttribute ? s = `will be replaced by the element property '${i.alternateAttribute}'` : s = `will be replaced by the '${i.alternateSlots}' slot` : s = "will be removed", console.warn(
        `Beacon Deprecation Warning: ${c} ${s} in foundation@${i.version}`
      );
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(t) {
    if (!t) return;
    const i = { ...this.resolvedDeferOptions }, s = re([
      t == null ? void 0 : t.root,
      i == null ? void 0 : i.root
    ]), c = re([
      t == null ? void 0 : t.rootMargin,
      i == null ? void 0 : i.rootMargin
    ]), b = re([
      t == null ? void 0 : t.threshold,
      i == null ? void 0 : i.threshold
    ]);
    this.resolvedDeferOptions = {
      root: s instanceof Document || s instanceof Element ? s : document,
      rootMargin: typeof c == "string" ? c : T.defaultDeferOptions.rootMargin,
      threshold: Array.isArray(b) || typeof b == "number" ? b : T.defaultDeferOptions.threshold
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    Ie(T.safari) || (this.style.visibility = T.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    Ie(T.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const t = '[defer-until]:not([defer-until="defined"])', i = this.closest(
      t
    );
    if (i && ke(i))
      return i;
    const s = this.getClosestHost();
    if (s) {
      const c = s.closest(
        t
      );
      if (c && ke(c))
        return c;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let t = this && this.parentNode;
    for (; t; ) {
      if (t instanceof ShadowRoot)
        return t.host;
      t = t.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(t) {
    return new Promise((i) => {
      t.includes(R.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), i();
      })) : t.includes(R.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), i();
      })) : i();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((t) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => t());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(t) {
    return new Promise((i) => {
      if (t === null)
        i();
      else if (Qe(t))
        this.selectDeferUntilHandler(t.deferList).then(
          () => i()
        );
      else {
        const s = (c) => {
          this.deferredChildEventHandler(c).then(() => {
            t.removeEventListener(
              L.DEFERRED_CHILD,
              s
            ), i();
          });
        };
        t.addEventListener(
          L.DEFERRED_CHILD,
          s
        );
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((t) => {
      if (!this.deferrable || this.motionState === "enabled")
        t();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => t());
      else {
        const i = this.getClosestDeferredParent();
        i ? this.handleParentalDeferUntil(i).then(
          () => t()
        ) : t();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(R.VISIBLE)) {
      const t = new IntersectionObserver((i) => {
        for (const s of i)
          s.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), t.disconnect());
      }, this.getResolvedDeferOptions() || null);
      t.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const t = this.tagName.toLowerCase().split("-beacon")[0];
    return t.startsWith("beacon") ? "" : t;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(t) {
    if (this.tagName) {
      const i = `${t ? `${t}-` : ""}${this.tagName}`;
      if (this.nestedComponents.forEach(
        (s) => s.registerComponent(t)
      ), !customElements.get(i)) {
        const s = class extends this {
        };
        Object.defineProperty(s, "name", {
          value: Ze(i)
        }), customElements.define(i, s), customElements.whenDefined(i).then(() => {
          const c = new CustomEvent(L.REGISTER, {
            detail: i
          });
          document.dispatchEvent(c);
        }).catch((c) => {
          console.error(
            `Error defining Beacon Component ${i} in CustomElementsRegistry: `,
            c
          );
        });
      }
    }
  }
  static renderGlobalRootStyles() {
    q ? this.globalRootStyles.forEach(
      (t, i) => {
        if (!document.adoptedStyleSheets.find(
          (s) => s.name === `beacon-global-root-styles-${i}`
        )) {
          const s = new ie(
            `beacon-global-root-styles-${i}`,
            t.toString()
          );
          document.adoptedStyleSheets.push(s);
        }
      }
    ) : this.globalRootStyles.forEach((t, i) => {
      if (document.getElementById(`beacon-global-root-styles-${i}`))
        return;
      const s = document.createElement("template");
      s.innerHTML = `
        <style id="beacon-global-root-styles-${i}">
          ${t.toString()}
        </style>
      `;
      const c = s.content.cloneNode(!0);
      document.head.append(c);
    });
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(t) {
    return t ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${t}` : t : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick() {
    W(this, L.CLICK, void 0, this.onBeaconClick);
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown() {
    W(this, L.KEYDOWN, void 0, this.onBeaconKeydown);
  }
  emitToggle() {
    W(this, L.TOGGLE, void 0, this.onBeaconToggle);
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild() {
    W(this, L.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(t) {
    this.emitKeydown();
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(t) {
    var i;
    try {
      if (!((i = this.constructor().mixins) == null ? void 0 : i.includes(t))) throw new Error(`This class does not implement ${t}.`);
      return !0;
    } catch (s) {
      return console.error(s), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(t, i) {
    try {
      if (!(t in this))
        throw new Error(`${t} does not exist on this: ${this}`);
      return this[t] === i;
    } catch (s) {
      return console.error(s), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender(...t) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender(...t) {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy(...t) {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const t = this.closest("[motion-state]"), i = t == null ? void 0 : t.getAttribute("motion-state");
    i && (i === "enabled" || i === "disabled") && (this.motionState = i);
  }
  /**
   * Removes the "defined" string value from defer-until attribute while leaving in place any other subString in the attribute.
   * This is a clean-up function called in connectedCallback that enables usage of applitools UltraFastGrid with defer-until="defined"
   * components.
   */
  removeDeferUntilDefined() {
    const t = this.getAttribute("defer-until");
    if (t) {
      const s = t.split(" ").filter((m) => m), c = s.length;
      if (c === 1 && s.includes("defined") || c === 0)
        this.removeAttribute("defer-until");
      else {
        const m = s.filter((f) => f !== "defined").join(" ");
        this.setAttribute("defer-until", m);
      }
    } else this.hasAttribute("defer-until") && !t && this.removeAttribute("defer-until");
  }
  renderLightDOMStyles() {
    q ? (this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    )) : (this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.renderStyles(
      "globalLightDOMStyles",
      "beacon-global-light-DOM-styles"
    ));
  }
  /**
   * Set custom state (using ElementInternals) on a component.
   *
   * A fallback when custom state isn't supported toggles a custom attribute that matches the state.
   *
   * States can be styled in CSS without the need to reflect a property.
   *
   * element-internals-polyfill will do the work of setting fallback attributes.
   *
   * @example
   * ```css
   * :host(:state(--custom-state)),
   * :host([state--custom-state]) {
   *  rule: value;
   * }
   * ```
   */
  setState(t, i = !0) {
    this._internals ? i ? this._internals.states.add(t) : this._internals.states.delete(t) : console.error(
      `Attempted to set state ${Te} on ${this.tagName} but internals are not available.`
    );
  }
  connectedCallback() {
    this.setMotionState(), this.removeDeferUntilDefined(), this.handleDefer().then(() => {
      super.connectedCallback(), Me(this, $) || (se.setHostEventHandlerForAnalytics(this, this.version), oe(this, $, !0)), v.renderGlobalRootStyles(), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), W(this, L.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
}, $ = new WeakMap(), v.styles = [Ae, Le, xe], v.tagName = "", v.nestedComponents = [], v.shadowRootOptions = {
  ...De.shadowRootOptions,
  delegatesFocus: !0
}, v.alternateAttributesMap = /* @__PURE__ */ new Map(), v.hasDeprecatedProperties = !1, v.mixins = [], v.lightDOMStyles = [], v.globalLightDOMStyles = [
  Je,
  Xe
], v.globalRootStyles = [Ye], v);
N([
  P({ attribute: "focus-override", type: Boolean, reflect: !0 })
], x.prototype, "focusOverride");
N([
  P({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], x.prototype, "resetSpacing");
N([
  P({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], x.prototype, "beaconTagName");
N([
  P({ attribute: "beacon-version", reflect: !0 })
], x.prototype, "version");
N([
  P({ attribute: "defer-until" })
], x.prototype, "deferUntil");
N([
  P({ attribute: "defer-options" })
], x.prototype, "deferOptions");
N([
  P({ attribute: "motion-state", reflect: !0 })
], x.prototype, "motionState");
N([
  Te()
], x.prototype, "prefersReducedMotion");
let pt = x;
export {
  _ as A,
  pt as B,
  ht as a,
  W as e,
  mt as i
};
